import { render } from "./PlansSidebar.vue?vue&type=template&id=f07f6f38"
import script from "./PlansSidebar.vue?vue&type=script&lang=js"
export * from "./PlansSidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__